module.exports = __webpack_public_path__ + "img/analytics_bolt.f69dd21.png";